import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Query, RequestConnection, Result } from "../../../../interfaces";
import { loadData } from "../../../connection";

export const FETCH_DATA_RECEIVED_REQUEST = 'FETCH_DATA_RECEIVED_REQUEST';
export const FETCH_DATA_RECEIVED_SUCCESS = 'FETCH_DATA_RECEIVED_SUCCESS';
export const FETCH_DATA_RECEIVED_FAILURE = 'FETCH_DATA_RECEIVED_FAILURE';


const mapConnections = (data: any[]) => {
    const items: RequestConnection[] = [];
  
    data.map((e: any) => {
      const item: RequestConnection = {
        id: e.id,
        content : e.content,
        owner : e.owner,
        from: e.user_created.first_name,
        type: e.user_created.role.name,
        status: e.request_status,
        to: e.user_created.email || ''
      }
  
      items.push(item);
    });
  
    return items;
  }
  
interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchReceivedDataRequest = () => {
    return {
        type: FETCH_DATA_RECEIVED_REQUEST,
    };
};

const fetchReceivedDataSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DATA_RECEIVED_SUCCESS,
        payload: data
    };
};

const fetchReceivedDataFailure = (error: any) => {
    return {
        type: FETCH_DATA_RECEIVED_FAILURE,
        payload: error,
    };
};

export const getReceived = (collection:string, query:Query, page:number, limit:number) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchReceivedDataRequest());
        try {
            const response = await loadData(collection || 'connection_request', query, page, limit);
            dispatch(fetchReceivedDataSuccess(
                {
                    values: mapConnections(response.data),
                    loading: false,
                    pagination: { limit, page, total: response.meta.total  || response.meta.filter_count}
                }
            ));
        } catch (error: any) {
            dispatch(fetchReceivedDataFailure(error.message));
        }
    };
};
